var _rect, _rect2, _rect3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiemens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 56,
    viewBox: "0 0 142 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    fill: "url(#paint0_linear_2362_2342)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    stroke: "#8CBEE4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 130,
    height: 44,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.326 35.7367V32.5537C20.1476 33.1289 21.7392 33.4165 23.1389 33.4165C25.0756 33.4165 26.0344 32.918 26.0344 31.9017C26.0344 31.5182 25.9002 31.2114 25.6125 30.943C25.3249 30.6745 24.5963 30.291 23.4074 29.8116C21.279 28.9487 19.8983 28.2009 19.2464 27.5873C18.4027 26.782 18 25.7657 18 24.5193C18 22.9277 18.6136 21.7197 19.8216 20.8952C21.0297 20.0706 22.5829 19.668 24.5196 19.668C25.5934 19.668 27.1274 19.8597 29.1408 20.2624V23.2921C27.6451 22.6976 26.2453 22.3908 24.9606 22.3908C23.1581 22.3908 22.2377 22.8894 22.2377 23.8865C22.2377 24.2508 22.4295 24.5576 22.7746 24.7877C23.0814 24.9795 23.9251 25.3822 25.2866 25.9958C27.2616 26.8586 28.5655 27.6257 29.2175 28.2584C30.0036 29.0254 30.3871 30.0034 30.3871 31.2306C30.3871 32.9755 29.6201 34.2986 28.1053 35.219C26.8781 35.9668 25.2674 36.3312 23.3115 36.3312C21.6816 36.312 20.0134 36.1203 18.326 35.7367ZM32.9566 35.986V19.9364H37.4628V35.986H32.9566ZM41.6046 35.986V19.9364H53.1672V22.8319H45.9382V26.456H52.2276V29.1021H45.9382V32.918H53.3398V35.986H41.6046ZM56.2928 35.986V19.9364H62.1412L66.2063 30.1951L70.3673 19.9364H75.9281V35.986H71.6521V24.6152L66.8966 36.1586H64.0971L59.4567 24.6343V36.0052H56.2928V35.986ZM80.0508 35.986V19.9364H91.6134V22.8319H84.4036V26.456H90.693V29.1021H84.4036V32.918H91.8052V35.986H80.0508ZM94.7773 35.986V19.9364H99.9929L105.535 30.6937V19.9364H108.718V35.986H103.636L97.9412 25.0945V35.986H94.7773ZM111.92 35.7367V32.5537C113.722 33.1289 115.333 33.4165 116.733 33.4165C118.67 33.4165 119.628 32.918 119.628 31.9017C119.628 31.5182 119.494 31.2114 119.226 30.943C118.938 30.6745 118.19 30.291 117.001 29.8116C114.892 28.9487 113.492 28.2009 112.84 27.5873C111.997 26.782 111.594 25.7657 111.594 24.5193C111.594 22.9469 112.208 21.7389 113.416 20.8952C114.624 20.0706 116.177 19.668 118.113 19.668C119.206 19.668 120.606 19.8405 122.332 20.1857L122.735 20.2624V23.2921C121.239 22.6976 119.839 22.3908 118.554 22.3908C116.752 22.3908 115.851 22.8894 115.851 23.8865C115.851 24.2508 116.023 24.5576 116.388 24.7877C116.675 24.9603 117.519 25.363 118.9 25.9958C120.856 26.8586 122.159 27.6257 122.831 28.2584C123.598 29.0254 124 30.0034 124 31.2306C124 32.9755 123.252 34.2986 121.738 35.219C120.491 35.9668 118.9 36.3312 116.944 36.3312C115.256 36.312 113.588 36.1203 111.92 35.7367Z",
    fill: "#00ABAD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2362_2342",
    x1: 73.4244,
    y1: 56,
    x2: 73.335,
    y2: -0.00372781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060B7",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiemens);
export default __webpack_public_path__ + "static/media/siemens.c1053e8fdeb3fc93731bc8988798166e.svg";
export { ForwardRef as ReactComponent };